import { render, staticRenderFns } from "./StudentsList.vue?vue&type=template&id=628fb269&scoped=true&"
import script from "./StudentsList.vue?vue&type=script&lang=js&"
export * from "./StudentsList.vue?vue&type=script&lang=js&"
import style0 from "./StudentsList.vue?vue&type=style&index=0&id=628fb269&prod&lang=scss&"
import style1 from "./StudentsList.vue?vue&type=style&index=1&id=628fb269&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fb269",
  null
  
)

export default component.exports